import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '../../components/ui/Button';
import { DebtRepaymentPlanWizard } from '../../components/liabilities/DebtRepaymentPlanWizard';
import { SectionSkeleton } from '../../components/common/SectionSkeleton';
import {
  useActiveRepaymentPlanQuery,
  useLiabilitiesQuery,
} from '../../features/liabilities/queries';
import { paths } from '../../routes/paths';
import pt from '../../locales/pt';
import { useQueryShellState } from '../../hooks/useQueryShellState';
import { cn } from '../../utils/cn';

const PAGE_PAD = 'px-4 pb-8 pt-2 md:px-0';

export function DividasPlan() {
  const { data: liabilities = [], isPending, isFetching } = useLiabilitiesQuery();
  const listShell = useQueryShellState({ data: liabilities, isPending, isFetching });
  const { data: activePlan } = useActiveRepaymentPlanQuery();

  const active = useMemo(
    () => liabilities.filter((l) => !l.is_archived && !l.is_paid_off),
    [liabilities],
  );

  if (listShell.showBlockingSkeleton) {
    return (
      <div className={cn('mx-auto flex max-w-lg flex-col gap-6', PAGE_PAD)}>
        <SectionSkeleton variant="card-grid" />
      </div>
    );
  }

  if (active.length === 0) {
    return (
      <div className={cn('mx-auto flex max-w-lg flex-col gap-4', PAGE_PAD)}>
        <header>
          <Button asChild variant="ghost" className="mb-2 -ml-2">
            <Link to={paths.dividas}>{pt.common.back}</Link>
          </Button>
          <h1 className="font-display text-2xl font-semibold text-foreground">
            {pt.liabilities.repaymentWizard.title}
          </h1>
        </header>
        <p className="text-sm text-muted-foreground">{pt.liabilities.plan.empty}</p>
        <Button asChild>
          <Link to={paths.dividas}>{pt.liabilities.addDebt}</Link>
        </Button>
      </div>
    );
  }

  return (
    <DebtRepaymentPlanWizard activeDebts={active} existingPlan={activePlan} />
  );
}

export default DividasPlan;
